import IRHMA1 from "../../../../images/content/introduction/irhma/irhma1.png";
import IRHMA2 from "../../../../images/content/introduction/irhma/irhma2.jpg";
import IRHMA3 from "../../../../images/content/introduction/irhma/irhma3.jpg";

export const IRHMAImages = [
	{
		id: "applia-member-ariston-group",
		imageUrl: IRHMA1,
		imageAlt: "pages.introduction.irhma.blocks.images.image1Alt",
	},
	{
		id: "applia-member-beko",
		imageUrl: IRHMA2,
		imageAlt: "pages.introduction.irhma.blocks.images.image2Alt",
	},
	{
		id: "applia-member-bsh",
		imageUrl: IRHMA3,
		imageAlt: "pages.introduction.irhma.blocks.images.image3Alt",
	},
];
